import React from 'react';
import FilterOption from './filter-option';
import { FilterPanel, FilterRow } from '../styles';
import {
  FilterType,
  FilterUISubPlacementEnum,
  IFilter,
} from 'src/components/price-list/types';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { useAppContext } from '@prisjakt/ui-app-context';
import { TitleMediumText } from '@prisjakt/ui/text/variants';

type AllFiltersProps = {
  filters: IFilter[];
  onToggleFilter: (e: FilterType) => void;
};

export const AllFilters = ({ filters, onToggleFilter }: AllFiltersProps) => {
  const { t } = useAppContext();
  const { getTranslatedLabel } = useOfferListFilterContext();
  const onProductTypeFilterChanged = (filterType: FilterType) => {
    onToggleFilter(filterType);
  };

  const getFilters = (filteredFilters: IFilter[]) =>
    filteredFilters
      .filter(filter => !!filter.hidden)
      .map(filter => {
        const label = getTranslatedLabel(t, filter.type);
        let isChecked = filter.active;
        if (filter.additive) {
          isChecked = !filter.active;
        }
        return (
          <FilterOption
            key={label}
            name={label}
            filterType={filter.type}
            defaultValue={isChecked}
            onFilterChangedHandler={onProductTypeFilterChanged}
            label={label}
          />
        );
      });

  const renderFilters = () => {
    const showOnlyFilters = filters.filter(
      filter => filter.subPlacement === FilterUISubPlacementEnum.SHOW_ONLY
    );

    const additiveFilters = filters.filter(
      filter => filter.subPlacement === FilterUISubPlacementEnum.ADDITIVE
    );

    return (
      <div>
        <FilterRow>
          <TitleMediumText>{t('filter', 'label.show-only')}</TitleMediumText>
          {getFilters(showOnlyFilters)}
        </FilterRow>
        <FilterRow>
          <TitleMediumText>{t('filter', 'label.add')}</TitleMediumText>
          {getFilters(additiveFilters)}
        </FilterRow>
      </div>
    );
  };

  return (
    <FilterPanel data-testid="FilterOptions">{renderFilters()}</FilterPanel>
  );
};
